"use client";

import Link from "next/link";
import type { FaqCategory } from "./faqTypes";
import { FAQ_CATEGORY_ICONS } from "./faqMeta";
import { FaqBrandMark } from "./FaqBrandMark";

export interface FaqHubViewProps {
  title: string;
  subtitle: string;
  hubIntro: string;
  backLabel: string;
  categories: FaqCategory[];
}

/**
 * FAQ hub layout: category cards that link to per-category FAQ pages.
 */
export function FaqHubView({
  title,
  subtitle,
  hubIntro,
  backLabel,
  categories,
}: FaqHubViewProps) {
  return (
    <div className="gruv-faq">
      <div className="gruv-faq__panel">
        <header className="gruv-faq__header">
          <FaqBrandMark />
          <h1 className="gruv-faq__title">{title}</h1>
          <p className="gruv-faq__subtitle">{subtitle}</p>
        </header>

        <Link href="/events" className="gruv-faq__back">
          <span className="gruv-faq__back-arrow" aria-hidden>
            ←
          </span>
          {backLabel}
        </Link>

        <p className="gruv-faq__hub-intro">{hubIntro}</p>

        <div className="gruv-faq__categories" data-testid="faq-categories">
          {categories.map((category) => {
            const icon = FAQ_CATEGORY_ICONS[category.id as keyof typeof FAQ_CATEGORY_ICONS] ?? "?";

            return (
              <Link
                key={category.id}
                href={`/faq/${category.id}`}
                className="gruv-faq__category-card"
                data-testid={`faq-category-card-${category.id}`}
              >
                <span className="gruv-faq__category-icon" aria-hidden>
                  {icon}
                </span>
                <span className="gruv-faq__category-label">{category.label}</span>
                <span className="gruv-faq__category-description">{category.description}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
